<template>
    <div>
        <Head>
            <title>Поточні замовлення</title>
        </Head>
        <Header pageName="Кабінет" :cart-count="$page.props.cartCount"/>
        <div class="mx-auto max-w-2xl mt-4 px-4 py-4 sm:px-6 sm:py-8 lg:max-w-7xl lg:px-8">
            <div class="p-6 bg-white shadow rounded-lg">
                <div class="mb-6">
                    <filters-modal
                        :show="showModalFilter"
                        :with-refresh-button="false"
                        :hide-additional="true"
                        :tomorrow-button="true"
                        :params="form.params"
                        :default-period="'today'"
                        @update:form="applyFilter"
                    />
                </div>
                <div class="tabs">
                    <button v-for="lake in lakes"
                            :key="lake.id"
                            class="btn-indigo mr-3"
                            :class="{'active-tab': lake.id === form.currentLakeId}"
                            @click="form.currentLakeId = lake.id">
                        {{ lake.name }}
                    </button>
                </div>
                <div class="p-6 bg-gray-100">
                    <div v-for="(dayData, date) in orders" :key="date">
                        <h2 class="text-xl font-bold py-3">{{ date }}</h2>
                        <div v-for="(typeData, typeId) in dayData.types">
                            <div v-if="typeData.orders">
                                <h4 class="text-xl font-semibold">{{ typeData.orders[0].type?.name ?? typeData.orders[0].fast_order?.name }}</h4>
                                <div class="flex flex-wrap">
                                    <div
                                        v-for="order in typeData.orders"
                                        :key="order.id"
                                        class="p-4 bg-white shadow rounded-lg mb-4 grid sm:grid-cols-1 md:grid-cols-1 gap-4 m-2"
                                    >
                                        <div class="border border-gray-300 rounded-lg p-4 flex flex-col items-start">
                                            <h3 class="text-lg font-semibold">
                                                {{ order.lake.name }} /
                                                {{ order.point?.name ?? order.fast_order?.name }}
                                            </h3>
                                            <div class="mt-auto pt-2">
                                                <p>Замовлення № {{ order.liqPayId }}</p>
                                                <p>{{ order.name }}</p>
                                                <p>{{ order.phone }}</p>
                                                <p>{{ order.quantity }} чол</p>
                                                <p v-if="order.category">{{ order.category.name }}</p>
                                                <p>{{ order.totalSum }} грн</p>
                                                <div v-if="order.attributes && order.attributes.length > 0" class="mt-2 pt-2 border-t border-gray-100">
                                                    <p class="text-xs font-semibold text-gray-500 mb-1">Атрибути замовлення:</p>
                                                    <div v-for="attr in order.attributes" :key="'a-' + attr.id" class="flex items-center justify-between text-xs gap-2">
                                                        <span class="text-gray-700">{{ attr.title }} — {{ attr.price }} грн</span>
                                                        <span :class="attr.is_payed ? 'text-green-600' : 'text-amber-500'" class="font-semibold whitespace-nowrap">
                                                            {{ attr.is_payed ? 'Оплачено' : 'Не оплачено' }}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div v-if="order.cabinet_attributes && order.cabinet_attributes.length > 0" class="mt-2 pt-2 border-t border-gray-100">
                                                    <p class="text-xs font-semibold text-gray-500 mb-1">Додаткові послуги:</p>
                                                    <div v-for="attr in order.cabinet_attributes" :key="'c-' + attr.id + '-' + attr.payed_at" class="flex items-center justify-between text-xs gap-2">
                                                        <span class="text-gray-700">{{ attr.title }} — {{ attr.price }} грн</span>
                                                        <span :class="attr.is_payed ? 'text-green-600' : 'text-amber-500'" class="font-semibold whitespace-nowrap">
                                                            {{ attr.is_payed ? 'Оплачено' : 'Не оплачено' }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Link} from "@inertiajs/inertia-vue3"
import Header from "@/Component/Header"
import FiltersModal from "@/Component/FiltersModal"
import {route} from "ziggy-js"
import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";

export default {
    name: "Dashboard",
    components: {
        Link,
        Header,
        FiltersModal
    },
    props: {
        cartCount: {
            type: Number,
            default: 0
        },
        user: {
            type: Object,
            default: () => ({}),
        },
        sort: {
            type: Object,
            default: {
                sortOrder: 'desc',
                sortBy: 'start_date'
            }
        },
        filters: Object,
        orders: Object,
        lakes: Object,
        fetchingLake: String
    },
    data() {
        return {
            showModalFilter: false,
            form: {
                params: this.filters.params,
                sort: this.sort,
                currentLakeId: parseInt(this.fetchingLake),
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get(this.$route('dashboard.watchman'), pickBy(this.form), {
                    preserveState: true,
                    preserveScroll: true,
                })
            }, 150),
        },
    },
    mounted() {
        this.intervalId = setInterval(this.refreshData, 60000)
    },
    beforeUnmount() {
        clearInterval(this.intervalId)
    },
    methods: {
        route,
        applyFilter($event) {
            this.form.params = $event
        },
        refreshData() {
            this.$inertia.get(this.route('dashboard.watchman'), pickBy(this.form), {
                preserveState: true,
                preserveScroll: true,
                replace: true,
            })
        },
    },
}
</script>
<style scoped>
.active-tab {
    --tw-bg-opacity: 1;
    background-color: rgba(251, 146, 60, var(--tw-bg-opacity));
}
</style>
